// // src/components/HfrRegister/MapRegister.jsx
// import React, { useEffect, useState } from "react";
// import { OpenStreetMapProvider } from "leaflet-geosearch";

// const MapRegister = () => {
//   const [geoQuery, setGeoQuery] = useState("");
//   const [geoSuggestions, setGeoSuggestions] = useState([]);

//   const provider = new OpenStreetMapProvider();

//   useEffect(() => {
//     const fetchSuggestions = async () => {
//       if (geoQuery.length < 3) {
//         setGeoSuggestions([]);
//         return;
//       }
//       const results = await provider.search({ query: geoQuery });
//       setGeoSuggestions(results);
//     };
//     fetchSuggestions();
//   }, [geoQuery]);

//   const handleSelect = (result) => {
//     setGeoQuery(result.label);
//     setGeoSuggestions([]);
//   };

//   return (
//     <div className='col-span-1 flex flex-col md:col-span-2'>
//       <input
//         type='text'
//         placeholder='Search a location'
//         value={geoQuery}
//         onChange={(e) => setGeoQuery(e.target.value)}
//         className='w-full rounded-t border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
//       />
//       {geoSuggestions.length > 0 && (
//         <ul className='relative z-10 max-h-40 overflow-y-auto rounded-b border border-t-0 border-gray-300 bg-white'>
//           {geoSuggestions.map((result, idx) => (
//             <li
//               key={idx}
//               className='cursor-pointer px-3 py-2 text-sm hover:bg-blue-100'
//               onClick={() => handleSelect(result)}
//             >
//               {result.label}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default MapRegister;
// src/components/HfrRegister/MapRegister.jsx
import { useEffect, useState } from "react";
import { OpenStreetMapProvider } from "leaflet-geosearch";

const MapRegister = () => {
  const [geoQuery, setGeoQuery] = useState("");
  const [geoSuggestions, setGeoSuggestions] = useState([]);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [isSelected, setIsSelected] = useState(false);

  const provider = new OpenStreetMapProvider();

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (geoQuery.length < 3 || isSelected) {
        setGeoSuggestions([]);
        return;
      }
      try {
        const results = await provider.search({ query: geoQuery });
        setGeoSuggestions(results);
      } catch (err) {
        console.error("Error fetching suggestions:", err);
      }
    };
    fetchSuggestions();
  }, [geoQuery, isSelected]);

  const handleSelect = (result) => {
    setGeoQuery(result.label);
    setLatitude(result.y);
    setLongitude(result.x);
    setGeoSuggestions([]);
    setIsSelected(true);
  };

  const handleChange = (e) => {
    setGeoQuery(e.target.value);
    setIsSelected(false);
  };

  return (
    <div className="col-span-1 flex flex-col gap-4 md:col-span-2">
      {/* Location search */}
      <div className="flex flex-col relative">
        <label className="mb-1 text-sm text-gray-600">Geographic Location</label>
        <input
          type="text"
          placeholder="Search a location"
          value={geoQuery}
          onChange={handleChange}
          className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        {geoSuggestions.length > 0 && (
          <ul className="absolute top-full left-0 w-full max-h-40 overflow-y-auto rounded border border-t-0 border-gray-300 bg-white shadow-md z-50">
            {geoSuggestions.map((result, idx) => (
              <li
                key={idx}
                className="cursor-pointer px-3 py-2 text-sm hover:bg-blue-100"
                onClick={() => handleSelect(result)}
              >
                {result.label}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Latitude */}
      <div className="flex flex-col">
        <label className="mb-1 text-sm text-gray-600">Latitude</label>
        <input
          type="number"
          value={latitude}
          onChange={(e) => setLatitude(e.target.value)}
          placeholder="Latitude"
          step="0.000001"
          min="-90"
          max="90"
          className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      {/* Longitude */}
      <div className="flex flex-col">
        <label className="mb-1 text-sm text-gray-600">Longitude</label>
        <input
          type="number"
          value={longitude}
          onChange={(e) => setLongitude(e.target.value)}
          placeholder="Longitude"
          step="0.000001"
          min="-180"
          max="180"
          className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>
    </div>
  );
};

export default MapRegister;
